import React, {Component} from "react";
import {tableConfig} from "../config/config";
import * as R from "ramda";
import {getValueFromDDL, mapToObjectDDL, removeNullFields} from "../../../../common/mapper";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import InventoryUnitTable from "../common/InventoryUnitTable";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import InventoryUnitDetail from "./modals/InventoryUnitDetail";
import InventoryUnitFilter from "./modals/InventoryUnitFilter";
import InventoryUnitStock from "./modals/InventoryUnitStock";
import InventoryUnitPrint from "./modals/InventoryUnitPrint";
import Api from "../../../../../Services/Api";
import SimplePrintTable from "../../../../../modules/popup/SimplePrintTable";
import { saveAs } from "file-saver";

class InventoryUnit extends Component {
    constructor(props) {
        super(props);
        this.tableConfig = tableConfig.unit;
        this.initialData = {
            id: null,
            kodeVariant: null,
            namaVariant: null,
            kodeWarna: null,
            namaWarna: null,
            segmenName: null,
            namaLokasi: null,
            rfs: null,
            nonRfs: null,
        };
        this.initialFilterData = {
            id: null,
            kodeVarian: null,
            kodeWarna: null,
            kodesegmen: null,
            kodeLocation: null,
            noMesin: null,
            noRangka: null,
            satuanRfs: null,
            umur: null,
        };
        this.initialSearch = {
            kodeVarian: null,
        };
        this.state = {
            loading: false,
            filterModalVisible: false,
            detailModalVisible: false,
            unitStockModalVisible: false,
            printModalVisible: false,
            selectedData: null,
            filterData: this.initialFilterData,
            search: this.initialSearch,
            dataTable: [],
            dataVariant: [],
            dataCabang: [],
            selectedCabangPrint: null,
            inventoryUnitPrintVisible: false,
            pagination: {
                count: 0,
                limit: 5,
                page: 1,
                orderBy: "id",
                sort: "ASC",
            },
            errorSelectCabangPrint: null,
        };
    }

    componentDidMount() {
        this.fetchDataVarian();
        this.fetchDataCabang();
    }

    handleResetPagination = () =>{
        this.setState({
          pagination: {
            count: 0,
            limit: 5,
            page: 1,
            orderBy: "id",
            sort: "ASC",
          },
        });
    }

    componentDidUpdate = async (prevProps, prevState) => {
        if (!R.equals(this.state.search.kodeCabang, prevState.search.kodeCabang)) {
            this.handleTriggerLoading();
            this.handleResetPagination()
            await this.fetchDataInventoryUnit({
                paramFilters: removeNullFields(this.parseFilterData(this.state.search)),
                limit: 5,
                page: 1
            });
            this.handleClearForm();
            this.handleTriggerLoading();
        }
    }

    handleModalDetailVisibility = (index) => {
        this.setState((prevValue) => ({
            ...prevValue,
            selectedData: {...prevValue.dataTable[index]},
            detailModalVisible: !prevValue.detailModalVisible,
        }));
    };

    handleModalUnitStocklVisibility = (index) => {
        this.setState((prevValue) => ({
            ...prevValue,
            selectedData: {...prevValue.dataTable[index]},
            unitStockModalVisible: !prevValue.unitStockModalVisible,
        }));
    };

    handleModalFilterVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            selectedData: this.initialData,
            selectedCabang: this.state.search.kodeCabang,
            filterModalVisible: !prevState.filterModalVisible,
        }));
    };
s
    handleSubmitFilter = async () => {
        try {
            this.handleTriggerLoading();
            this.setState(prev=>({
                ...prev,
                pagination: {
                ...prev.pagination,
                  page: 1,
                  limit: 5,
                }
            }), async () => {
                await this.fetchDataInventoryUnit({
                    paramFilters: {
                        ...removeNullFields(this.parseFilterData(this.state.filterData)),
                        kodeCabang: this.state.search.kodeCabang.value,
                    },
                    limit: 5,
                    page: 1
                })
            })
        } catch (error) {
            console.log("errors: ", error);
        } finally {
            this.handleClearSearch();
            this.handleModalFilterVisibility();
            this.handleTriggerLoading();
        }
    };

    handleInventoryUnitPrintVisibility = () => {
        this.setState((prev) => ({
            ...prev,
            inventoryUnitPrintVisible: !prev.inventoryUnitPrintVisible,
            selectedCabangPrint: null,
            errorSelectCabangPrint: null
        }));
    }

    handlePrint = async () => {
        if(!this.state.selectedCabangPrint){
            this.setState({ errorSelectCabangPrint: "Pilih cabang terlebih dahulu" });
            return
        } else {
            this.setState({ errorSelectCabangPrint: null})
        }
        try {
            this.handleTriggerLoading();
            const res = await Api.create("NAGAMAS_TRANSACTION_FILE").downloadInventoryUnitExcel({
                paramFilters: {
                    kodeCabang: this.state.selectedCabangPrint?.map(item => item.value)
                }
            })
            console.log(res)
            if(res.ok){
                const blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                saveAs(blob, 'INVENTORY_UNIT.xlsx')
            }
        } catch (error) {
            console.log(error)
        }
        this.handleTriggerLoading();
        this.handleInventoryUnitPrintVisibility();
    }

    handleFilterValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
            },
        }));
    };

    handleSearchValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            search: {
                ...prevValue.search,
                [name]: value,
            },
        }));
    };

    handleSearchByVariant = async (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            search: {
                ...prevValue.search,
                [name]: value,
            },
        }));

        this.handleTriggerLoading();
        // this.handleResetPagination()
        await this.fetchDataInventoryUnit({
            paramFilters: removeNullFields(this.parseFilterData({
                ...this.state.search,
                kodeVarian: value
            })),
            limit: 5,
            page: 1
        });
        this.handleClearForm();
        this.handleTriggerLoading();

    }

    handleClearForm = () => {
        this.setState((prevValue) => ({...prevValue, filterData: this.initialFilterData}));
    };

    handleClearSearch = () => {
        this.setState((prevState) => ({
            ...prevState,
            search: {
                ...prevState.search,
                ...this.initialSearch
            },
        }));
    };

    handleChangePage = async (page, limit, callback) => {
        this.handleTriggerLoading();
        this.setState(callback);

        const filterRequest = removeNullFields(this.parseFilterData(this.state.filterData))
        const searchRequest = removeNullFields(this.parseFilterData(this.state.search))

        let paramFilters;
        if (!R.isEmpty(filterRequest)) {
            paramFilters = {...filterRequest};
        } else {
            paramFilters = {...searchRequest};
        }

        await this.fetchDataInventoryUnit({
            paramFilters: {
                ...paramFilters,
                kodeCabang: this.state.search.kodeCabang?.value
            },
            page: page,
            limit: limit
        });
        this.handleTriggerLoading();
    }

    handleChangeRowsPerPage = async (page, limit, callback) => {
        this.handleTriggerLoading();
        this.setState(callback);

        const filterRequest = removeNullFields(this.parseFilterData({
            ...this.state.filterData,
            kodeCabang: this.state.search.kodeCabang
        }))
        const searchRequest = removeNullFields(this.parseFilterData(this.state.search))

        let paramFilters;
        if (!R.isEmpty(filterRequest)) {
            paramFilters = {...filterRequest};
        } else {
            paramFilters = {...searchRequest};
        }

        await this.fetchDataInventoryUnit({
            paramFilters: {
                ...paramFilters,
                kodeCabang: Array.isArray(this.state.search.kodeCabang?.value) ? this.state.search.kodeCabang?.value : [this.state.search.kodeCabang?.value]
            },
            page: page,
            limit: limit
        });
        this.handleTriggerLoading();
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchDataInventoryUnit = async (body) => {
        try {
            let response = await Api.create("NAGAMAS_TRANSACTION").getAllInventoryUnitByParam(
                body && Object.keys(body).length > 0
                    ? body :
                    {
                        paramFilters: {},
                        page: 1,
                        limit: 5,
                    }
            )
            if (response.ok) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataTable: response.data.data,
                    pagination: {
                        ...prevValue.pagination,
                        count: response.data.totalData || 0,
                    }
                }));
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    fetchDataVarian = async () => {
        try {
            let response = await Api.create("NAGAMAS_MASTER_DATA").getAllVariant()
            if (response.ok) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataVariant: response.data.data,
                }));
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    fetchDataCabang = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
            if (res.ok) {
                let filteredData = res.data.data.filter(
                    item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
                );

                if (filteredData.length !== 0) {
                    this.setState((prevValue) => ({
                        ...prevValue,
                        dataCabang: filteredData,
                        search: {
                            ...prevValue.search,
                            kodeCabang: mapToObjectDDL(filteredData[0].namaDealer, [filteredData[0].kodeCabang]),
                        }
                    }));
                }
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    parseFilterData(data) {
        return {
            ...data,
            kodeCabang: getValueFromDDL(data, "kodeCabang"),
            kodeVarian: getValueFromDDL(data, "kodeVarian"),
            kodeWarna: getValueFromDDL(data, "kodeWarna"),
            kodesegmen: getValueFromDDL(data, "kodesegmen"),
            kodeLocation: getValueFromDDL(data, "kodeLocation"),
            satuanRfs: getValueFromDDL(data, "satuanRfs"),
        };
    }

    handleSelectCabangPrint = (value) =>{
        this.setState({ selectedCabangPrint: value })
    }

    render() {
        return (
            <>
                <FlexView style={{justifyContent: "space-between"}} className="margin-bottom-5px margin-top-5px">
                    <FlexView vAlignContent="center">
                        <SimpleDDL
                            id="select_options_nama_cabang"
                            box="search"
                            name="kodeCabang"
                            containerclassname="width width-250px"
                            placeholder="Nama cabang hak akses"
                            options={
                                this.state.dataCabang.map(
                                    item => mapToObjectDDL(item.namaDealer, [item.kodeCabang])
                                )
                            }
                            value={this.state.search.kodeCabang}
                            onChange={(value, {name}) => this.handleSearchValueChange(name, value)}
                        />
                    </FlexView>
                    <FlexView vAlignContent="center">
                        <SimpleDDL
                            id="select_options_nama_variant"
                            box="search"
                            name="kodeVarian"
                            containerclassname="width width-250px"
                            placeholder="Kode Varian"
                            isClearable={true}
                            value={this.state.search.kodeVarian}
                            options={this.state.dataVariant ? this.state.dataVariant.map(
                                item => ({
                                    label: item.kodeVariant,
                                    value: item.kodeVariant,
                                    name: item.namaVariant
                                })) : null}
                            onChange={(value, {name}) => this.handleSearchByVariant(name, value)}
                        />
                        <input
                            {...this.props}
                            className="txt txt-sekunder-color margin-left-5px margin-bottom-15px"
                            type="text"
                            disabled={true}
                            value={this.state.search.kodeVarian ? this.state.search.kodeVarian.name : ""}
                        />
                        <SimpleButton
                            onClick={this.handleModalFilterVisibility}
                            styles={{width: "unset", marginBottom: "15px"}}
                            icon={<i className={"fa fa-qrcode"}></i>}
                        />
                    </FlexView>
                </FlexView>

                <InventoryUnitTable
                    tableConfig={this.tableConfig}
                    data={this.state.dataTable}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    pagination={this.state.pagination}
                    actionButtons={
                        (tableMeta) => {
                            return (
                                <FlexView vAlignContent="center" style={{gap: "15px"}}>
                                    <SimpleButton
                                        category="action_button"
                                        icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-lg fa-eye"></i>}
                                        onClick={() => this.handleModalDetailVisibility(tableMeta.rowIndex)}
                                    />
                                    <SimpleButton
                                        category="action_button"
                                        icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-lg fa-clipboard"></i>}
                                        onClick={() => this.handleModalUnitStocklVisibility(tableMeta.rowIndex)}
                                    />
                                </FlexView>
                            )
                        }
                    }
                    additionalButtons={
                        <FlexView vAlignContent="center">
                            <SimpleButton
                                onClick={() => this.handleInventoryUnitPrintVisibility()}
                                text={"Print"}
                            />
                        </FlexView>
                    }
                />

                {this.state.detailModalVisible && (
                    <InventoryUnitDetail
                        selectedData={this.state.selectedData}
                        visible={this.state.detailModalVisible}
                        onClickClose={this.handleModalDetailVisibility}
                    />
                )}

                {this.state.unitStockModalVisible && (
                    <InventoryUnitStock
                        selectedData={this.state.selectedData}
                        visible={this.state.unitStockModalVisible}
                        kodeCabang={this.state.search.kodeCabang}
                        onClickClose={this.handleModalUnitStocklVisibility}
                    />
                )}

                {this.state.filterModalVisible && (
                    <InventoryUnitFilter
                        filterData={this.state.filterData}
                        visible={this.state.filterModalVisible}
                        selectedCabang={this.state.selectedCabang}
                        onSubmit={this.handleSubmitFilter}
                        onValueChange={this.handleFilterValueChange}
                        onClearForm={this.handleClearForm}
                        onClickClose={this.handleModalFilterVisibility}
                    />
                )}

                {this.state.inventoryUnitPrintVisible && (
                  <InventoryUnitPrint
                    visible={this.state.inventoryUnitPrintVisible}
                    dataCabang={this.state.dataCabang}
                    selectedCabang={this.state.selectedCabangPrint}
                    handleSelectCabang={this.handleSelectCabangPrint}
                    onPrint={this.handlePrint}
                    error={this.state.errorSelectCabangPrint}
                    onClickClose={this.handleInventoryUnitPrintVisibility}
                  />
                )}
                <SimpleLoadingOverlay active={this.state.loading}/>
            </>
        );
    }
}

export default InventoryUnit;